import React, { useEffect, useMemo } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { Button, Grid, Paper } from '@material-ui/core';
import { TreeSelector } from './../TreeSelector';
import styles from './styles';
import {
  getCountries,
  getRegions,
  getStates,
} from '../../redux/actions/regionsActions';
import { useTranslation } from 'react-i18next';

interface AFIProps {
  value: any[];
  textButton?: string;
  includeStates?: boolean;
  onChange?: (value: any[]) => void;
  onApply?: () => void;
}

export function AvailabilityFilterList({
  value,
  textButton = '',
  includeStates = false,
  onChange = (values: any[]) => {},
  onApply = () => {},
}: AFIProps) {
  const classes = styles();
  const dispatch: any = useDispatch();
  const { t } = useTranslation();

  const { regions, countriesByRegion, statesByCountry }: any = useSelector(
    (state: RootStateOrAny) => state.RegionsReducer,
  );

  const places = useMemo(() => {
    const rootNode = {
      type: 'Root',
      text: 'Global',
      path: '/',
      metas: {
        regionId: 'GLOBAL',
      },
      hasChildren: true,
    };

    

    const regionNodes = regions.map(region => {
      const regionPath = `${rootNode.path}${region.id}`;
      return {
        type: 'Region',
        text: region.name,
        path: regionPath,
        hasChildren: true,
        metas: {
          regionId: region.id,
        },
        children: countriesByRegion[region.id]?.map(country => {
          const countryPath = `${regionPath}/${country.id}`;
          return {
            type: 'Country',
            text: t(
              `app.common.countries.${country.iso3}`,
              country.description,
            ),
            path: countryPath,
            hasChildren: includeStates,
            metas: {
              regionId: region.id,
              countryId: country.id,
            },
            children: includeStates
              ? statesByCountry[country.id]?.map(state => ({
                  type: 'State',
                  text: state.description,
                  path: `${countryPath}/${state.id}`,
                  hasChildren: false,
                  metas: {
                    regionId: region.id,
                    countryId: country.id,
                    stateId: state.id,
                  },
                }))
              : [],
          };
        }).sort(
          function (a,b) {
          const aName = (a.text || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"");
          const bName = (b.text || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"");
          return aName > bName ? 1 : ( aName < bName ? -1 : 0 );
        })
      };
    });
    return [{ ...rootNode, children: regionNodes }];
  }, [regions, countriesByRegion, statesByCountry]);

  useEffect(() => {
    if (regions?.length === 0) {
      dispatch(getRegions());
    }
  }, []);

  const handleLocationTreeExpanded = ({ type, metas }: any) => {
    switch (type) {
      case 'Region':
        if (!countriesByRegion[metas.regionId]) {
          dispatch(getCountries(metas.regionId));
        }
        break;
      case 'Country':
        if (!statesByCountry[metas.countryId]) {
          dispatch(getStates(metas.regionId, metas.countryId));
        }
        break;
      default:
        break;
    }
  };
  const handleChange = (selection: any[]) => {
    onChange(selection);
  };

  return (
    <div>
      <Paper className={classes.paperStyle} elevation={0}>
        <Grid container>
          <Grid item xs={9} />
          <Grid item xs={3}>
            <Button
              variant="contained"
              color="primary"
              classes={{ label: classes.label, root: classes.button }}
              onClick={onApply}
            >
              {textButton || t('app.common.filter')}
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <TreeSelector
        nodes={places}
        value={value}
        onNodeExpanded={handleLocationTreeExpanded}
        onChange={handleChange}
        disableStoresIcon={true}
      />
    </div>
  );
}
